/* @flow */
import React from 'react';

import CopySubscriberDialog from 'groups/components/CopySubscriberDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import GroupStore from 'groups/stores/GroupStore';
import MenuItem from 'components/MenuItem.jsx';
import Relationship from 'entities/Relationship';
import Subscriber from 'entities/Subscriber';
import { mountModal } from 'lib/modal';
import { promiseRelationship } from 'chat/utils/ChatPromises';

class SubscribeUserMenuItem extends React.Component {
  static propTypes = {
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
  };

  clickCopyDialog = () => {
    promiseRelationship(this.props.subscriber)
      .then(relationship => {
        this.renderCopyDialog(relationship);
      }
    );
  };

  renderCopyDialog = (relationship: Relationship) => {
    const groups = GroupStore.getOwnedGroups();
    mountModal(
      <CopySubscriberDialog
        relationship={relationship}
        groups={groups}
      />,
      this
    );
  };

  render() {
    return (
      <MenuItem onClick={() => this.clickCopyDialog()}>
        <Glyph name="arrow-right" />
        <span>
          Copy to another class
        </span>
      </MenuItem>
    );
  }
}

export default SubscribeUserMenuItem;



// WEBPACK FOOTER //
// ./src/user/components/SubscribeUserMenuItem.jsx